import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AppSettings} from '../../constants';
import {Modal} from 'react-bootstrap';
import FSButton from 'components/Button';
import Form from 'components/react-validation/components/form';
import componentActions from '../../components/actions';
import Input from 'components/react-validation/components/input';
import * as Vali from '../../helper/validator-helper';
import Select from 'components/react-validation/components/select';
import Submit from 'components/react-validation/components/submit';
import usersAction from '../actions';
import isEmpty from 'lodash/isEmpty';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import * as UserActionType from '../constants';

const MODAL_NAME = 'Edit User';

class EditUserModal extends Component {
  static MODAL_NAME = MODAL_NAME;
  static propTypes = {
    usersAction: PropTypes.object,
    search: PropTypes.string,
    toggleModal: PropTypes.func,
    modalName: PropTypes.string,
    errorMsg: PropTypes.array,
    item: PropTypes.object,
    title: PropTypes.string,
    dispatch:PropTypes.func
  }
  constructor(props) {
    super(props);
    this.state = {
      isCloseRestrict:props.item.restrictWOCloseOption,
      selectedValue:props.item.roleName
    };
  }
  componentDidMount(){
    this.fetchUsersCloseOption();
  }

  fetchUsersCloseOption(){
    this.props.dispatch({
      type: UserActionType.FETCH_USER_CLOSE_OPTION_ASYNC,
      params: this.props.item.email,
      callback:(res)=>{
       this.setState({
        isCloseRestrict:res.restrictWOCloseOption
       })
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    if (!isEmpty(nextProps.errorMsg)) {
      // this.setState({
      //   errorMsg: nextProps.errorMsg
      // });
      if (this.form) {
        this.form.showError(this.refs['email'], nextProps.errorMsg);
      }
      document.querySelector('.btn-siteone').removeAttribute('disabled');
    } else {
      // this.props.toggleModal({ modalName: '', ActiveModal: null });
    }
  }

  closeModal = () => {
    this.props.toggleModal({ modalName: '', ActiveModal: null });
  }

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onSubmit(e);
    }
  }

  onSubmit(e) {
    e.preventDefault();
    const search = this.props.search;
    let data =this.form.getValues();
    data['restrictWOCloseOption'] = this.state.isCloseRestrict;
    this.props.usersAction.updateUserAsync({
      params: {
        data: data,
        search: search
      },
      callback: this.closeModal
    });
    document.querySelector('.btn-siteone').setAttribute('disabled', true);
  }
  onCheckCloseRestrict = () => {
    this.setState({
      isCloseRestrict: !this.state.isCloseRestrict,
    });
  };
  render() {
    const { modalName, item } = this.props;
    let { firstName, lastName, email, status,restrictWOCloseOption } = item;
    if (this.form) {
      firstName = this.form.getValues().firstName;
      lastName = this.form.getValues().lastName;
      email = this.form.getValues().email;
    }
    return (
      <div className=''>
        <Modal
          show={modalName === MODAL_NAME}
          onHide={this.closeModal}
          dialogClassName='custom-modal'
          backdrop='static'
          keyboard={false}
          container={this}
          id='rename-modal'
        >
          <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
            <Modal.Header>
              <Modal.Title id='contained-modal-title-lg'>{this.props.title}</Modal.Title>
              <button
                className='close '
                onClick={() => {
                  this.closeModal();
                }}
              >
                <i className='icon-icn_close' />
              </button>
            </Modal.Header>
            <Modal.Body>

              {/* <ul id='frm-errorMsg'>{this.props.errorMsg.map(msg => {
                return <li className='cls-danger help-block'>{msg}</li>;
              })}
              </ul> */}
              <Input type='hidden' name='redirectUrl' value={AppSettings.REDIRECT_URL_EMAIL_CONFIRM} />
              <Input type='hidden' name='resendInviteUrl' value={AppSettings.REDIRECT_URL_INVITE} />
              <Input type='hidden' name='userId' value={this.props.item.userId} />
              <div className='form-group'>
                <label>First name <span className='text-danger'>*</span></label>
                <Input type='text'
                  name='firstName'
                  ref='firstName'
                  value={firstName}
                  placeholder='First name'
                  onKeyPress={this.onEnter.bind(this)}
                  className='form-control'
                  max='40'
                  maxLength='40'
                  validations={[Vali.required, Vali.maxlength]} />
              </div>
              <div className='form-group'>
                <label>Last name <span className='text-danger'>*</span></label>
                <Input type='text'
                  name='lastName'
                  ref='lastName'
                  value={lastName}
                  placeholder='Last name'
                  onKeyPress={this.onEnter.bind(this)}
                  className='form-control'
                  max='40'
                  maxLength='40'
                  validations={[Vali.required, Vali.maxlength]} />
              </div>
              <div className='form-group'>
                <label>Email address <span className='text-danger'>*</span></label>
                <div className='info-text'>
                  <small>
                    Updating the email address blocks this user from the SiteOne system until the new email address is confirmed.
                  </small>
                </div>
                <Input type='text'
                  name='email'
                  ref='email'
                  value={email}
                  placeholder='Email address'
                  onKeyPress={this.onEnter.bind(this)}
                  className='form-control'
                  max='256'
                  maxLength='256'
                  disabled={status === 2}
                  validations={[Vali.required, Vali.email, Vali.maxlength]} />
              </div>
              <div className='form-group'>
                <label>Role <span className='text-danger'>*</span></label>
                <Select value={this.state.selectedValue} name='RoleName' className='form-control' validations={[Vali.required]} disabled={item.status !== 1} onChange={(data)=>{
                  this.setState({
                    selectedValue: data.target.value
                  })
                }}>
                  {
                    Object.keys(AppSettings.ROLES).map((key) => {
                      const name = AppSettings.LIST_ROLES.filter(t => { return t.key === AppSettings.ROLES[key]; })[0].value;
                      if (key === this.state.selectedValue) {
                        return <option value={AppSettings.ROLES[key]} selected>{name}</option>;
                      } else {
                        return <option value={AppSettings.ROLES[key]}>{name}</option>;
                      }
                    })}
                </Select>
              </div>
              {this.state.selectedValue === "BuilderUser"&&
              <CheckBoxSingle
                    checked={this.state.isCloseRestrict}
                    onChecked={this.onCheckCloseRestrict}
                    ref={(c) => {
                    this.check = c;
                    }}
                    label='Enable "Close Work Order" option'
                    className='checkbox-default'
                    style={{ marginLeft: '5px' }}
                    name='isRestrictClose'
                    />
              }
            </Modal.Body>

            <Modal.Footer >
              <FSButton type='button' kind='flat' className='btn btn-primary margin-right-5 btn-siteone-default' onClick={this.closeModal} label='Cancel'/>
              <Submit className='btn btn-primary btn-siteone'>Save</Submit>
            </Modal.Footer>

          </Form>

        </Modal>
      </div>
    );

  }
}

const mapStateToProps = (state) => {
  return {
    errorMsg: state.UserStore.ErrorMsg
  };
};
const mapDispatchToProps = dispatch => {
  return {
    toggleModal: bindActionCreators(componentActions.toggleModal, dispatch),
    usersAction: bindActionCreators(usersAction, dispatch),
    dispatch                
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditUserModal);



// WEBPACK FOOTER //
// ./src/User/Containers/EditUserModal.js